<template>
	<div class="content">
		<!-- <ul class="nav nav-pills nav-pills-primary justify-content-center" role="tablist">
			<li class="nav-item">
				<a class="nav-link active" data-toggle="tab" href="#nav1-ccp" role="tablist" aria-expanded="true">
					CCP
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-exchange-partner" role="tablist" aria-expanded="false">
					EXCHANGE PARTNER
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-full-member" role="tablist" aria-expanded="false">
					FULL MEMBER
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-ib" role="tablist" aria-expanded="false">
					IB
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-client" role="tablist" aria-expanded="false">
					CLIENT
				</a>
			</li>
		</ul>
		
		<div class="tab-content tab-space">
			<div class="tab-pane active" id="nav1-ccp" aria-expanded="true">
				<CentralCounterParty></CentralCounterParty>
			</div>

			<div class="tab-pane" id="nav1-exchange-partner" aria-expanded="false">
				<ExchangePartner></ExchangePartner>
			</div>

			<div class="tab-pane" id="nav1-full-member" aria-expanded="false">
				<FullMember></FullMember>
			</div>
			
			<div class="tab-pane" id="nav1-ib" aria-expanded="false">
				<IB></IB>
			</div>

			<div class="tab-pane" id="nav1-client" aria-expanded="false">
				<Clients></Clients>
			</div>
		</div> -->


		<CentralCounterParty v-if="this.$store.getters.getAccountLevel == 'ccp'"></CentralCounterParty>
		
		<ExchangePartner v-if="this.$store.getters.getAccountLevel == 'lp'"></ExchangePartner>
		
		<FullMember v-if="this.$store.getters.getAccountLevel == 'fm'"></FullMember>		
		
		<IB v-if="this.$store.getters.getAccountLevel == 'ib'"></IB>
		
		<Clients v-if="this.$store.getters.getAccountLevel == 'client'"></Clients>
	</div>
</template>

<script>
	import CentralCounterParty from '@/components/reconcile-reporting-system/CentralCounterParty.vue'
	import ExchangePartner from '@/components/reconcile-reporting-system/ExchangePartner.vue'
	import FullMember from '@/components/reconcile-reporting-system/FullMember.vue'
	import IB from '@/components/reconcile-reporting-system/IB.vue'
	import Clients from '@/components/reconcile-reporting-system/Clients.vue'

	export default {
		name: 'ReconcileReportingSystem',
		components: {
			CentralCounterParty,
			ExchangePartner,
			FullMember,
			IB,
			Clients,
		}
	}
</script>